import createHasSubmitFailed from './selectors/hasSubmitFailed';
import plain from './structure/plain';

export default createHasSubmitFailed(plain);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/hasSubmitFailed.js
// module id = 1761
// module chunks = 2